module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm11"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/005_FM1"
    }
  }, [_vm._v("Setting the scene")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Buses along The South West Coast Path:")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/006_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "note01"
  }, [_vm._v("1.")]), _vm._v(" Minehead to Ilfracombe")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/007_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "note01"
  }, [_vm._v("2.")]), _vm._v(" Ilfracombe to Boscastle")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "note01"
  }, [_vm._v("3.")]), _vm._v(" Boscastle to Newquay")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "note01"
  }, [_vm._v("4.")]), _vm._v(" Newquay to St Just")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "note01"
  }, [_vm._v("5.")]), _vm._v(" St Just to Falmouth")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "note01"
  }, [_vm._v("6.")]), _vm._v(" Falmouth to Plymouth (Jennycliff Bay)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "note01"
  }, [_vm._v("7.")]), _vm._v(" Plymouth (Jennycliff Bay) to Paignton")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "note01"
  }, [_vm._v("8.")]), _vm._v(" Paignton to Seaton")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "note01"
  }, [_vm._v("9.")]), _vm._v(" Seaton to South Haven Poin")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/5-00.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0